import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { useStoreSelector } from './store/store';

import ProviderChangesHandler from './components/ProviderChangesHandler/providerChangesHandler';
import RegisterPage from './components/RegisterPage/RegisterPage';

import '../src/components/LoadingPage/loading.scss';

const WarningRequestModal = React.lazy(() => import ('./components/Modals/WarningRequestModal/WarningRequestModal'));
const ChangeDepositModal = React.lazy(() => import ('./components/Modals/changeRequestModal/changeRequestModal'));
const TransactionModal = React.lazy(() => import ('./components/Modals/TransactionModal/transactionModal'));
const WithdrawModal = React.lazy(() => import ('./components/Modals/WithdrawModal/WithdrawModal')); 
const HistoryModal = React.lazy(() => import ('./components/Modals/HistoryModal/HistoryModal'));
const DepositModal = React.lazy(() => import ('./components/Modals/DepositModal/depositModal'));
const ConnectionPage = React.lazy(() => import('./components/ConnectionPage2/ConnectionPage'));
const SettingsPage =  React.lazy(() => import ('./components/SettingsPage/settingsPage'));
const InfoModal = React.lazy(() => import ('./components/Modals/InfoModal/infoModal'));
const HedgerPage = React.lazy(() => import ('./components/HedgerPage/HedgerPage'));
const Loading = React.lazy(() => import ('./components/LoadingPage/loading'));
const ProPage = React.lazy(() => import ('./components/PoolsPage/PoolsPage'));

 
function App() {

	const { historyModal, transactionModal, infoModal, withdrawModal, depositModal, changeDepositModal, warningRequestModal } = useStoreSelector(store => store.modals);
  	const { transactionStatus, chrClientAddr, isIniting } = useStoreSelector(store => store.app);


		return (
		<div className='App'>

			{chrClientAddr ?		
				<Switch>
					<Route exact path='/'>
						<ProPage/>
						{/* <MainPage/> */}
					</Route>
					<Route exact path='/settings'>
						<SettingsPage/>
					</Route>
					<Route exact path='/hedger'>
						<HedgerPage/>
					</Route>
					<Redirect to='/'/>
				</Switch>
			: 
				!isIniting 
					? <Switch>
						<Route>
							<ConnectionPage/>
						</Route>
					</Switch>
					: <RegisterPage/>
			}

			<ProviderChangesHandler/>

			<Suspense fallback={<Loading/>}>
				{depositModal && <DepositModal/>}
				{withdrawModal && <WithdrawModal/>}
				{historyModal && <HistoryModal/>}
				{changeDepositModal && <ChangeDepositModal/>}
				{warningRequestModal && <WarningRequestModal/>}
			</Suspense>
			<Suspense fallback={<Loading/>}>
				{transactionModal && transactionStatus && <TransactionModal/>}
			</Suspense>
			<Suspense fallback={<Loading/>}>
				{infoModal && <InfoModal/>}
			</Suspense>
		</div>
  	);
}

export default App;